import { useQuery } from 'react-query';

import Auth from 'src/services/api/auth/Auth';
import { queryKeys } from 'src/services/api/constants';

export const useLoggedInUser = () => {
    return useQuery(
        [queryKeys.loggedInUser],
        async () => Auth.getLoggedInUser(),
        {
            enabled: !!Auth.accessToken,
            retry: false,
            refetchOnWindowFocus: false,
        }
    );
};
